import InlineSVG from 'react-inlinesvg';

function Loading() {
	return (
		<div className="spinner">
			<InlineSVG
				className="icon"
				src={`${process.env.PUBLIC_URL}/assets/icons/spinner.svg`}
			/>
		</div>
	);
}

export default Loading;
